export function outline() {
  const para = document.querySelectorAll(".js-outline");
  const novelP = document.querySelectorAll(".js-outline-section");

  if (para[0]) {
    window.addEventListener("scroll", function() {
        //目次のあるボックスを指定の位置でクラスを追加する
        const indexDistance = document.querySelector(".js-outline-content").getBoundingClientRect().top;
        const indexDistanceB = document.querySelector(".js-outline-content").getBoundingClientRect().bottom;
        if (indexDistance < 100){
            document.querySelector(".js-outline-list").classList.add("fixed");
        } else if (indexDistance > 200) {
            document.querySelector(".js-outline-list").classList.remove("fixed");
        }
        if (indexDistanceB < 350){
            document.querySelector(".js-outline-list").classList.remove("fixed");
        }

        //段落が現れたら、要素にクラスactiveを追加、消えたら削除
        for (let i = 0; i < novelP.length; i++) {
            const novelPDistance = novelP[i].getBoundingClientRect().top;
            if (novelPDistance < 185) {
                novelP[i].classList.add("is-active");
                para[i].classList.add("is-active");
                if (novelP[i-1]!=null) { //novelP[i-1]が存在する場合
                    novelP[i-1].classList.remove("is-active")
                    para[i-1].classList.remove("is-active")
                }
            } else {
                novelP[i].classList.remove("is-active");
                para[i].classList.remove("is-active");
            }
        }
    })
  }
}
